import Vue from 'vue'
import Vuex from 'vuex'
import user from './modules/user'
import dataCenter from './modules/dataCenter'
import routerUrl from './modules/routerUrl'
import getters from './getters'

Vue.use(Vuex)

const store = new Vuex.Store({
    modules: {
        user,
        dataCenter,
        routerUrl
    },
    getters
})

export default store
